// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHsaDetailsResponseDto
 */
export interface IHsaDetailsResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof IHsaDetailsResponseDto
     */
    plan_year_valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IHsaDetailsResponseDto
     */
    plan_year_valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof IHsaDetailsResponseDto
     */
    cip_closure_days?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IHsaDetailsResponseDto
     */
    pend_contributions_for_cip?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IHsaDetailsResponseDto
     */
    investment_threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof IHsaDetailsResponseDto
     */
    funding_method?: IHsaDetailsResponseDtoFundingMethodEnum;
}

/**
* @export
* @enum {string}
*/
export enum IHsaDetailsResponseDtoFundingMethodEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}


/**
 * Check if a given object implements the IHsaDetailsResponseDto interface.
 */
export function instanceOfIHsaDetailsResponseDto(value: object): value is IHsaDetailsResponseDto {
    return true;
}

export function IHsaDetailsResponseDtoFromJSON(json: any): IHsaDetailsResponseDto {
    return IHsaDetailsResponseDtoFromJSONTyped(json, false);
}

export function IHsaDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_year_valid_from': json['plan_year_valid_from'] == null ? undefined : (new Date(json['plan_year_valid_from'])),
        'plan_year_valid_to': json['plan_year_valid_to'] == null ? undefined : (new Date(json['plan_year_valid_to'])),
        'cip_closure_days': json['cip_closure_days'] == null ? undefined : json['cip_closure_days'],
        'pend_contributions_for_cip': json['pend_contributions_for_cip'] == null ? undefined : json['pend_contributions_for_cip'],
        'investment_threshold': json['investment_threshold'] == null ? undefined : json['investment_threshold'],
        'funding_method': json['funding_method'] == null ? undefined : json['funding_method'],
    };
}

export function IHsaDetailsResponseDtoToJSON(json: any): IHsaDetailsResponseDto {
    return IHsaDetailsResponseDtoToJSONTyped(json, false);
}

export function IHsaDetailsResponseDtoToJSONTyped(value?: IHsaDetailsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_year_valid_from': value['plan_year_valid_from'] == null ? undefined : ((value['plan_year_valid_from']).toISOString().substring(0,10)),
        'plan_year_valid_to': value['plan_year_valid_to'] == null ? undefined : ((value['plan_year_valid_to']).toISOString().substring(0,10)),
        'cip_closure_days': value['cip_closure_days'],
        'pend_contributions_for_cip': value['pend_contributions_for_cip'],
        'investment_threshold': value['investment_threshold'],
        'funding_method': value['funding_method'],
    };
}

